import { Controller } from 'react-hook-form';
import { AsyncPaginate } from 'react-select-async-paginate';
import { adminAPI } from 'services/admin';

const defaultLoadOptions = async ({ responseKey, requestUrl }, prevOptions) => {
  const newOffset = prevOptions.length;

  try {
    const response = await adminAPI.get(`${requestUrl}${newOffset}`);
    const data = response[responseKey];
    const total = response.totalItemsCountFiltered;

    const options = data.map(data => ({
      label: data.name || data.key, // Posíveis labels
      value: data.id || data.userId, // Possíveis chaves para id
    }));

    return {
      options: options,
      hasMore: newOffset + options.length < total, // Verifique se há mais itens a serem carregados
    };
  } catch (error) {
    return { options: [], hasMore: false };
  }
};

export const OptionField = ({
  label,
  field,
  control,
  requestUrl,
  responseKey,
}) => {
  return (
    <Controller
      label={label}
      name={field}
      control={control}
      render={({ field: { onChange, value, defaultValue } }) => (
        <AsyncPaginate
          styles={{
            control: baseStyles => ({
              ...baseStyles,
              zIndex: 1,
              '&:hover': {
                borderColor: '#464646',
              },
              borderRadius: '5px',
              width: 'auto',
            }),
            singleValue: base => ({
              ...base,
              borderRadius: 6,
              color: '#B7B5BE',
              fontSize: '15px',
              display: 'flex',
            }),
            menu: provided => ({
              ...provided,
              zIndex: 3,
            }),
          }}
          theme={theme => ({
            ...theme,
            borderRadius: 0,
            colors: {
              ...theme.colors,
              primary25: '#e9e9ea',
              primary: '#0A6CCF',
              width: 'auto',
            },
          })}
          loadOptions={(_, previous) =>
            defaultLoadOptions(
              {
                requestUrl,
                responseKey,
              },
              previous
            )
          }
          noOptionsMessage={() => 'Nada encontrado'}
          loadingMessage={() => 'Carregando...'}
          onBlurResetsInput={false}
          onCloseResetsInput={false}
          className="basic-single"
          classNamePrefix="select"
          isSearchable={false}
          isClearable={true}
          autoload={true}
          value={{ value: value.value, label: value.label }}
          onChange={selected => {
            onChange(selected || defaultValue);
          }}
        />
      )}
    />
  );
};
